
export enum ServerErrorType {
    DATA_CONFLICT = "DATA_CONFLICT"
}
